import { Fragment } from "react";
import CustomTabs from "../../../components/CustomTabs/CustomTabs";
import TablePaginated from "../../../components/TablePaginated/TablePaginated";
import {
  BALANCE_HEADERS,
  BALANCE_SUMMARY_HEADERS,
} from "../constants/table-headers";
import { BalanceList } from "../../../modules/storage/models/storage-dto";
import CardDataNotFound from "../../../components/CardDataNotFound/CardDataNotFound";

interface StorageTableProps {
  handleTabChange: (newTab: number) => void;
  handlePageChange: (newPage: number) => void;
  tab: number;
  page: number;
  balanceList: BalanceList;
  isLoading: boolean;
}

const StorageTable: React.FC<StorageTableProps> = ({
  handleTabChange,
  handlePageChange,
  tab,
  page,
  balanceList,
  isLoading,
}) => {
  return (
    <Fragment>
      <CustomTabs
        tabsHeader={["Saldo", "Extrato"]}
        onChangeTab={(event) => handleTabChange(Number(event))}
      />
      {!isLoading && !balanceList.rows.length ? (
        <CardDataNotFound
          icon="search-empty"
          title="Dados não Encontrados"
          subtitle={`Não foram encontrados dados de saldo de cota referente a consulta realizada. Tente com uma consulta diferente.`}
        />
      ) : (
        <TablePaginated
          isLoadingData={isLoading}
          columns={tab ? BALANCE_HEADERS : BALANCE_SUMMARY_HEADERS}
          data={balanceList.rows}
          rowsPerPage={10}
          paginationProps={{
            pagesTotal: Math.ceil(balanceList.count / 10) || 1,
            page,
          }}
          onChangePage={handlePageChange}
        />
      )}
    </Fragment>
  );
};

export { StorageTable };
